import { PricingCardConfig } from "../pricing/components/pricing-card";

// Prices of omni documents are entered manually, never derived from the positions.
export const omniPricingCardConfig: PricingCardConfig = {
  usePositionsSwitch: false,
  activeSwitch: true,
};
